<template>
  <div class="step-progress-bar local-hero">
    <div class="step-wrapper">
      <template v-if="programMonth">
        <!-- Step 1 (Impact statement or Goal progression) -->
        <template v-if="stepName == 'Goal Progression'">
          <div class="step-number-text" v-translate="{ stepNumber: 1, stepCount: stepCount }">
            Step %{stepNumber} of %{stepCount}
          </div>
        </template>

        <!-- Step 2 (Documentation) -->
        <template v-else-if="stepName == 'Documentation'">
          <div class="step-number-text" v-translate="{ stepNumber: 2, stepCount: stepCount }">
            Step %{stepNumber} of %{stepCount}
          </div>
        </template>

        <!-- Step 3 (Payment details or program exit) -->
        <template v-else-if="stepName == 'Program Exit'">
          <div class="step-number-text" v-translate="{ stepNumber: 3, stepCount: stepCount }">
            Step %{stepNumber} of %{stepCount}
          </div>
        </template>
      </template>

      <template v-if="stepName">
        <div
          class="step-number-text"
          v-if="stepNumber && numberOfSteps"
          v-translate="{ stepNumber: stepNumber, stepCount: stepCount }">
            Step %{stepNumber} of %{stepCount}
          </div>
        <div class="step-description-text">
          {{ stepName }}
        </div>
      </template>
      <template v-else>
        <div class="step-description-text">
          {{ organizationDetails.name }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NomineeProgressBar',
  props: {
    stepNumber: {
      type: Number,
      default: null,
    },
    numberOfSteps: {
      type: Number,
      default: null,
    },
    stepName: {
      type: String,
      default: '',
    },
    programMonth: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState(['organizationDetails', 'organizationCssVars']),
    stepCount() {
      if(this.numberOfSteps)
        return this.numberOfSteps

      let currentProgramMonth = this.programMonth
      if (currentProgramMonth >= 2 && currentProgramMonth <= 11) {
        return 2
      } else {
        return 3
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.step-progress-bar {
  display: flex;
  justify-content: center;

  .step-wrapper {
    @include tablet-and-up-screen {
      max-width: 70%;
    }
  }

  .step-number-text {
    font-size: 1.25rem;
    line-height: 1.75rem;

    @include tablet-screen {
    }

    @include desktop-screen {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  .step-description-text {
    font-size: 2rem;
    font-weight: bold;
    line-height: 2.5rem;

    @include tablet-screen {
      font-size: 2.25rem;
      line-height: 2.8rem;
    }

    @include desktop-screen {
      font-size: 3rem;
      line-height: 3.75rem;
    }
  }
}
</style>
